import { useState, useEffect } from 'react'
import { authHeaders } from 'croods-auth'
import useCroodsAuthStorage from 'auth/useCroodsAuthStorage'
import useCurrentUser from 'auth/useCurrentUser'
import hasSubscriberPrivilege from 'ui/header/hasSubscriberPrivilege'

export const useUserType = () => {
  const [{ currentUser, validating }] = useCurrentUser()
  const authStorage = useCroodsAuthStorage()
  const headers = authHeaders(authStorage)
  const [startedValidation, setStartedValidation] = useState(false)

  useEffect(() => {
    if (validating === true && !startedValidation) {
      setStartedValidation(true)
    }
  }, [startedValidation, validating])

  if (headers['Access-Token'] === undefined) {
    return 'visitor'
  }

  if (!currentUser && (validating || !startedValidation)) {
    return 'pending'
  }

  if (currentUser && currentUser.userType) {
    if (currentUser.userType === 'user') {
      return currentUser.subscribed ? 'subscribed' : 'unsubscribed'
    }
    return currentUser.userType // admin or operator
  }

  return 'visitor'
}

export const useIsNonPaying = () => {
  const userType = useUserType()
  return ['pending', 'visitor', 'unsubscribed'].includes(userType)
}

export const useHasSubscriberPrivilege = () => {
  const [{ currentUser }] = useCurrentUser()
  return hasSubscriberPrivilege(currentUser)
}

export const useIsFreemium = () => {
  const [{ currentUser }] = useCurrentUser()
  return (
    currentUser?.freemiumVersion > 0 &&
    currentUser?.subscriberStatus === 'Non Converter'
  )
}
